import { ChainId } from '@pancakeswap/sdk'

export const SUPPORT_ONLY_BSC = [ChainId.BSC]
export const SUPPORT_ONLY_BASE = [ChainId.BASE, ChainId.BASE_GOERLI]
export const SUPPORT_FARMS = [
  ChainId.BSC,
  ChainId.BSC_TESTNET,
  ChainId.ETHEREUM,
  ChainId.GOERLI,
  ChainId.ZKSYNC_TESTNET,
  ChainId.POLYGON_ZKEVM_TESTNET,
  ChainId.BASE_GOERLI,
  // TODO: ADD BASE MAINNET CHAIN : When the farms are in, they are active
  // ChainId.BASE,
]
